<template>
  <div>
    <v-data-table :headers="headers" :items="licitacionParticipantes">
      <template v-slot:[`item.fallo.asistio`]="{ item }">
        <template v-if="item.fallo">
          <v-icon
          v-if="item.fallo.asistio"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
        </template>
      </template>
      <template v-slot:[`item.fallo.ganador`]="{ item }">
        <template v-if="item.fallo">
          <v-icon
          v-if="item.fallo.ganador"
          class="amber--text">
            mdi-crown
          </v-icon>
        </template>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <template v-if="!item.fallo">
          <v-tooltip
          v-if="mixValidaScopesActions(2)"
          top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="nuevoFalloParticipante(item)"
              >
                <v-icon>mdi-folder-plus</v-icon>
              </v-btn>
            </template>
            <span>Propuesta del Participante</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-tooltip
            v-if="mixValidaScopesActions(2)"
            top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="editarFalloParticipante(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Fallo del Participante</span>
          </v-tooltip>
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoFalloLicitacionDesktop',
  props: {
    licitacionParticipantes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      existeGanador: false,
      headers: [
        {
          text: '¿Ganador?', width: '100', align: 'center', value: 'fallo.ganador',
        },
        { text: 'Razón Social', value: 'contratista.nombreRazonSocial' },
        {
          text: '¿Asistió?', width: '100', align: 'center', value: 'fallo.asistio',
        },
        {
          text: '',
          value: 'acciones',
          align: 'end',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    nuevoFalloParticipante(participanteLicitacion) {
      this.buscaGanador();
      const hayGanador = this.existeGanador;
      eventBus.$emit('agregar-fallo-participante', participanteLicitacion, hayGanador);
      this.existeGanador = false;
    },
    editarFalloParticipante(participanteLicitacion) {
      this.buscaGanador();
      const hayGanador = this.existeGanador;
      eventBus.$emit('editar-fallo-participante', participanteLicitacion, hayGanador);
      this.existeGanador = false;
    },
    buscaGanador() {
      this.licitacionParticipantes.forEach((item) => {
        if (item.fallo) {
          if (item.fallo.ganador) {
            this.existeGanador = true;
          }
        }
      });
    },
  },
  computed: {

  },
};
</script>

<style lang="scss">
</style>
